



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations } from "vuex";

@Component
export default class Login extends Vue {

    private loginForm: any = {
        userName: localStorage.getItem('userName'),
        password: localStorage.getItem('password')
    };
    private rules = {
        userName: [{ required: true, message: '请输入用户名称', trigger: 'blur' },],
        password: [{ required: true, message: '请输入用户密码', trigger: 'blur' }]
    };

    create() {
    }

    onReset() {
        this.$router.push("/reset");//利用路由跳转页面，path为你定义的路由配置中要跳转页面的path
    }

    onRegister() {
        this.$message({
            type: 'error',
            message: '暂不提供注册功能请联系暂不开放系统注册功能，请联系支队信通或指挥中心注册用户！!'
        });
        //this.$router.push("/register");//利用路由跳转页面，path为你定义的路由配置中要跳转页面的path
    }

    async onLogin() {
        (this.$refs.loginForm as HTMLFormElement).validate((valid: boolean) => {
            if (valid) {

                this.$apis.login(this.loginForm.userName, this.loginForm.password)
                    .then((res: any) => {


                        this.$store.state.userInfo = res.data.userInfo;
                        this.$store.state.token = res.data.token;
                        this.$store.state.needUpdatePassword = res.data.needUpdatePassword;
                        this.$store.state.machineId = localStorage.getItem("machineId");
                        if (!this.$store.state.machineId) {
                            this.$store.state.machineId = this.generateUUID();
                            localStorage.setItem("machineId", this.$store.state.machineId); // session存储token
                        }

                        //sessionStorage.setItem("token", res.data.token); // session存储token
                        //sessionStorage.setItem("userInfo", JSON.stringify(res.data.userInfo)); // session存储token

                        localStorage.setItem("userName", this.loginForm.userName); // session存储token
                        localStorage.setItem("password", this.loginForm.password); // session存储token

                        // 存储用户密码
                        /*if (this.remember) {
                            localStorage.setItem("userName", this.loginForm.userName);
                            localStorage.setItem("password", this.loginForm.password);
                        } else {
                            localStorage.clear();
                        }*/
                        if (res.data.needUpdatePassword) {
                            this.$router.push("/my/password");
                            this.$message({
                                type: 'warning',
                                message: '您的密码过于简单，请立即修改密码后，才能继续操作!'
                            });
                        }
                        else
                            this.$router.push("/");
                        //this.$router.push("/");//利用路由跳转页面，path为你定义的路由配置中要跳转页面的path


                    });
            }
        });
    }

    generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }
}
